var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftNavigation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 264,
    viewBox: "0 0 286 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 44C0 19.6995 19.6995 0 44 0H242C266.301 0 286 19.6995 286 44V220C286 244.301 266.301 264 242 264H44C19.6995 264 0 244.301 0 220V44ZM264 88H22V220C22 232.15 31.8497 242 44 242H242C254.15 242 264 232.15 264 220V88ZM44 33C37.9249 33 33 37.9249 33 44V44.11C33 50.1851 37.9249 55.11 44 55.11H44.11C50.1851 55.11 55.11 50.1851 55.11 44.11V44C55.11 37.9249 50.1851 33 44.11 33H44ZM66 44C66 37.9249 70.9249 33 77 33H77.11C83.1851 33 88.11 37.9249 88.11 44V44.11C88.11 50.1851 83.1851 55.11 77.11 55.11H77C70.9249 55.11 66 50.1851 66 44.11V44ZM110 33C103.925 33 99 37.9249 99 44V44.11C99 50.1851 103.925 55.11 110 55.11H110.11C116.185 55.11 121.11 50.1851 121.11 44.11V44C121.11 37.9249 116.185 33 110.11 33H110Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 79H275V121H11V79Z",
    fill: "white",
    stroke: "#B6B6B6",
    strokeWidth: 22
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99 121L99 253L44 253C25.7746 253 11 238.225 11 220L11 121L99 121Z",
    stroke: "#B6B6B6",
    strokeWidth: 22
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftNavigation);
export default __webpack_public_path__ + "static/media/left_navigation.7ada2b06874b960ffb2d738e92a251fd.svg";
export { ForwardRef as ReactComponent };